import axios from "axios";

const state = {
    invoices: [],
	invoice: {},
};

const actions = {
    async loadInvoices(context){
        return axios.get("/api/invoices").then(function(response){
            console.log(response)
			context.commit("setInvoices", response.data);
        })
    },
	async loadInvoice(context,number){
        return axios.get("/api/invoice",{params:{number:number}}).then(function(response){
            console.log(response)
			context.commit("setInvoice", response.data);
        })
    },
}

const mutations = {
    setInvoices(state,data){
        state.invoices = data;
    },

	setInvoice(state,data){
        state.invoice = data;
    },

}

const getters = {
    invoices(state){
        return state.invoices;
    },
	invoice(state){
        return state.invoice;
    },
};
  
export default {
    state,
    actions,
    mutations,
    getters
};